import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-available-products',
  templateUrl: './available-products.component.html',
  styleUrls: ['./available-products.component.scss']
})
export class AvailableProductsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
